import { action, makeAutoObservable } from "mobx";

import { SignalHookFormState, SignalHookScopeType } from "./types";
import { createEmptyHook } from "./utils";

export class SignalHookStore {
  id: string;
  bindingId: number | null;
  scopeType: SignalHookScopeType;
  sampleRate: number;
  labelNames: string[];
  promptId?: number;
  promptName?: string;
  promptFolderId: number | null;
  versionNumber: number | null;
  versionLabel: string | null;
  variantType: "version" | "label" | null;

  constructor(initial?: SignalHookFormState) {
    const state = initial ?? createEmptyHook();
    this.id = state.id;
    this.bindingId = state.bindingId;
    this.scopeType = state.scopeType;
    this.sampleRate = state.sampleRate;
    this.labelNames = state.labelNames;
    this.promptId = state.promptId;
    this.promptName = state.promptName;
    this.promptFolderId = state.promptFolderId ?? null;
    this.versionNumber = state.versionNumber ?? null;
    this.versionLabel = state.versionLabel ?? null;
    this.variantType = state.variantType ?? null;

    makeAutoObservable(this);
  }

  get formState(): SignalHookFormState {
    return {
      id: this.id,
      bindingId: this.bindingId,
      scopeType: this.scopeType,
      sampleRate: this.sampleRate,
      labelNames: this.labelNames,
      promptId: this.promptId,
      promptName: this.promptName,
      promptFolderId: this.promptFolderId,
      versionNumber: this.versionNumber,
      versionLabel: this.versionLabel,
      variantType: this.variantType,
    };
  }

  @action
  update(updater: (hook: SignalHookFormState) => SignalHookFormState) {
    const next = updater(this.formState);
    this.scopeType = next.scopeType;
    this.sampleRate = next.sampleRate;
    this.labelNames = next.labelNames;
    this.promptId = next.promptId;
    this.promptName = next.promptName;
    this.promptFolderId = next.promptFolderId ?? null;
    this.versionNumber = next.versionNumber ?? null;
    this.versionLabel = next.versionLabel ?? null;
    this.variantType = next.variantType ?? null;
  }
}
